import { PropsWithChildren } from "react";
import OverflowTooltip from "../Tooltips/OverflowTooltip";

export default function SidePanelActionBar(
  p: PropsWithChildren<{
    text: React.ReactNode;
  }>,
) {
  return (
    <div className="flex items-center">
      <OverflowTooltip className="h-6 text-lg">{p.text}</OverflowTooltip>
      <div className="flex flex-1 items-center justify-end">{p.children}</div>
    </div>
  );
}
